<!--
     Copyright (c) 2024-2026 Broadcom. All Rights Reserved.
     Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
     and/or its subsidiaries.
-->

<button type="button"
        class="btn btn-link"
        [title]="label | vtranslate"
        (click)="click($event)"
        (mouseleave)="copied = false">
    <cds-icon *ngIf="mode === StringActionMode.CopyToClipboard"
              shape="copy-to-clipboard">
    </cds-icon>
    <cds-icon *ngIf="mode === StringActionMode.PasteFromClipboard"
              shape="paste">
    </cds-icon>
    <cds-icon *ngIf="mode === StringActionMode.DownloadFile"
              shape="download">
    </cds-icon>
    <cds-icon *ngIf="mode === StringActionMode.UploadFile"
              shape="upload">
    </cds-icon>
</button>

<span *ngIf="copied" class="copied-label">
    {{'copy.to.clipboard.copied' | vtranslate}}
</span>

<clr-signpost>
    <span clrSignpostTrigger></span>
    <ng-template [clrIfOpen]="error !== null"
                 (clrIfOpenChange)="errorSignpostChanged($event)">
        <clr-signpost-content [clrPosition]="'top-middle'">
            {{ error | vtranslate}}
        </clr-signpost-content>
    </ng-template>
</clr-signpost>

<input *ngIf="mode === StringActionMode.UploadFile"
       class="upload-file-input"
       #fileInput
       type="file"
       accept="text/plain"
       (change)="handleFile($event)">
